import React from 'react';
import { Link, useRouter } from '@sls-react/routing';
import A, { AnchorProps } from '@sls-react/components/Links/A';
import { LinkProps } from 'next/link';
import { useSession } from '@sls-react/contexts/SessionContext';
import LoginLink from '@sls-react/components/Links/LoginLink';

type Props = AnchorProps & {
  linkProps?: LinkProps;
  page?: 'purchase' | 'purchaseComplete';
};

const GiftCardLink: React.FC<Props> = ({
  children,
  linkProps,
  page,
  ...props
}) => {
  const { loggedIn } = useSession();
  const router = useRouter();

  if (page === 'purchase') {
    if (loggedIn) {
      return (
        <Link href="/gift-cards/purchase" passHref>
          <A {...props} aria-label="Purchase gift cards here">
            {children}
          </A>
        </Link>
      );
    } else {
      return (
        <LoginLink
          onSuccessfulLogin={() => router.push('/gift-cards/purchase')}
          message="To purchase gift cards, create a SidelineSwap account"
          aria-label="Purchase gift cards here"
          {...props}
        >
          {children}
        </LoginLink>
      );
    }
  }

  return (
    <Link href="/gift-cards" passHref>
      <A {...props} aria-label="Buy or redeem gift cards here">
        {children}
      </A>
    </Link>
  );
};

export default GiftCardLink;
